import { Component } from '@angular/core';
import { ApprovalCreateFormComponent } from './approval-create-form/approval-create-form.component';
import { ApprovalListComponent } from './approval-list/approval-list.component';

@Component({
  selector: 'fnsr-approval',
  standalone: true,
  imports: [ApprovalCreateFormComponent, ApprovalListComponent],
  templateUrl: './approval.component.html',
  styleUrls: ['./approval.component.scss']
})
export class ApprovalComponent {

}
